module.exports = __webpack_public_path__ + "img/icon-iso14001.36991ed9.png";